<template>
	
<com-section v-on:back="onBackClick" :section="section">

	<slot></slot>

	<com-form v-if="step === 1" :section="section" v-on:next="step = 2" />
	<com-summary v-if="step === 2" :section="section" />

</com-section>

</template>

<script>

import comSection from '@/components/tool/common/Section'
import comForm from './record/Form'
import comSummary from './record/Summary'

export default {

	props: ['section'],

	components: {
		'com-section': comSection,
		'com-form': comForm,
		'com-summary': comSummary
	},

	data: function() {

		return {
			step: 1
		}

	},

	computed: {

		hasSupplementText: function() {

			return (this.$getValue('aid.supplements.recommended') === 1) ? this.supplements[this.$getValue('aid.supplements.action')] : false

		},

		selected: function() {

			return (this.$isPatient) ? [] : this.$store.getters['logic/variable'](this.$store.getters['data/setup'].treatments.variable)

		},

		hasNone: function() {

			return this.$_.contains(this.selected, 0)

		}

	},

	created: function() {

		if (!this.selected.length || this.hasNone) this.step = 2

	},

	methods: {

		onBackClick: function() {

			if (this.step === 1) {

				this.$emit('back')

			} else {

				this.step = 1

			}

		}

	}

}

</script>

<style scoped>

</style>